import React, { ReactElement } from 'react';
import { ToastContainer, ToastContainerProps } from 'react-toastify';

type Props = ToastContainerProps;

const Toaster : React.FC<Props> = (props) : ReactElement => {
    return (
        <ToastContainer {...props} />
    );
};

export default Toaster;
